// extracted by css-extract-rspack-plugin
export default {"AuthorLink":"CommitAttribution-module__AuthorLink__DV7CP","CommitAttributionContainer":"CommitAttribution-module__CommitAttributionContainer__I_rfs"};